const getters = {
  hasAuthorized: state => state.permission.hasAuthorized,
  userInfo: state => state.user.userInfo, //用户信息
  userName: state =>  (state.user.token !== 'undefined' && state.user.token != null && state.user.token !== '') ? 
  (state.user.userInfo.UserName ? 
    state.user.userInfo.UserName : 
    state.user.userInfo.LoginName.substr(0, 3) + '****' + state.user.userInfo.LoginName.substr(7)):"",
  token: state => state.user.token,
  PerfectInformation: state => state.user.PerfectInformation, //是否需要完善信息
  rolesName: state => (state.user.token !== 'undefined' && state.user.token != null && state.user.token !== '')   ? state.user.userInfo.Roles.length > 0 ? state.user.userInfo.Roles[0].Name : "" : "",
  Verifyphonenumber: state => state.user.Verifyphonenumber, //是否需要跳转到验证手机号界面  state => state.user.Verifyphonenumber
  sitestyle: state => state.theme.sitestyle,
  Useridentity: state => state.user.Useridentity,
  external: state => state.user.external,
  UserOnline:state => state.user.UserOnline,
  Ischangepassword:state => state.user.Ischangepassword,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js